import React, { useEffect } from "react";
import "./OurKeyFeatures.css";
import AOS from "aos";
import "aos/dist/aos.css";

// Material Icons
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import BrowserUpdatedIcon from "@mui/icons-material/BrowserUpdated";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import AppSettingsAltIcon from "@mui/icons-material/AppSettingsAlt";

const features = [
  {
    icon: <SavedSearchIcon />,
    seriesNumber: "01",
    title: "Analyze the Business Requirements",
    description:
      "We assess your society's needs and brainstorm before advancing.Our digital solutions help businesses worldwide overcome modern challenges with a digital-first approach.",
  },
  {
    icon: <AppRegistrationIcon />,
    seriesNumber: "02",
    title: "Planning & Designing",
    description:
      "In the Plan & Design phase, we define the website’s structure and craft an intuitive UI/UX. Our team creates wireframes and prototypes, ensuring a seamless user experience before moving to development.",
  },
  {
    icon: <BrowserUpdatedIcon />,
    seriesNumber: "03",
    title: "Development & Implementation",
    description:
      "Our skilled developers follow agile methodologies to build and implement the app in manageable sprints.Next, we plan the features and functionalities to be added to the app.",
  },
  {
    icon: <AppSettingsAltIcon />,
    seriesNumber: "04",
    title: "Deployment & Maintenance",
    description:
      "After planning, the development phase begins where the full framework is structured and coding is completed. Once finalized, the solution is deployed, and ongoing maintenance ensures it remains efficient, updated, and aligned with evolving business needs.",
  },
  {
    icon: <QueryStatsIcon />,
    seriesNumber: "05",
    title: "Quality Assurance & Testing ",
    description:
      "After development, we thoroughly test the app to fix bugs and ensure smooth performance. We also provide hands-on training sessions so your team can easily understand, operate, and manage the system",
  },
  {
    icon: <VolunteerActivismIcon />,
    seriesNumber: "06",
    title: "Handover & Maintenance",
    description:
      "We gather user feedback and analyze performance to identify areas for improvement. Once all functionalities are verified to be up-to-date and working correctly, the final handover is completed.",
  },
];

const OurKeyFeatures = () => {
  useEffect(() => {
    AOS.init({
      once: true,
      duration: 1000,
      offset: 120,
    });
  }, []);

  return (
    <section className="ourkeyFeacturesSection">
      <div className="container">
        <h5 className="industriesTitle" data-aos="fade-down">
          -- Starlinklab Work process
        </h5>
        <h1 className="ourKeyfeacturesHeading" data-aos="fade-up">
          Your Success , <span className="techTitle">Our Process</span>
        </h1>
        <p
          className="mt-4 text-lg text-gray-400 OurProcessDescription"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          At StarlinkLab, we do more than just build websites and apps—we create smart digital solutions tailored to your business. Our expert team works with you every step to bring your ideas to life. Join the brands that trust us to turn their vision into powerful, future-ready products.
        </p>

        <p
          className="text-lg text-gray-400 quote"
          data-aos="fade-up"
          data-aos-delay="300"
          style={{ marginTop: "0px" }}
        >
          “ Empowering Ideas with Cutting-Edge Web & App Solutions. ”
        </p>
        <div className="timeline">
          {features.map((feature, index) => (
            <div
              key={index}
              className="featureCard"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="iconWrapper">
                <div className="icon">{feature.icon}</div>
              </div>
              <p className="seriesNumber">{feature.seriesNumber}</p>
              <h5 className="featureTitle">{feature.title}</h5>
              <p className="featureDescription">
                {feature.description}
                <button className="hoverButton"></button>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurKeyFeatures;
